import { createSelector } from '@ngrx/store';
import { selectAllRendezvousRequests } from './entity-store-selectors';

export function selectRendezvousRequestById(id: string) {
  return createSelector(selectAllRendezvousRequests, (rr) => {
    return rr.find((r) => r.id === id && r.cancelledAt == null);
  });
}

export function selectRendezvousRequestByRequestLocationId(requestLocationId: string) {
  return createSelector(selectAllRendezvousRequests, (rr) => {
    return rr.find((r) => r.requestLocationId === requestLocationId && r.cancelledAt == null);
  });
}
